module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/24HourFeatured3.webp";